import React from "react";
import Table from "@/shared/components/organisms/Table";
import ColumnPersonInformationAvatar from "@/shared/components/molecules/ColumnPersonInformationAvatar";
import ColumnDate from "@/shared/components/molecules/ColumnDate";
import { getOptionsStatusBusiness } from "@/shared/constants/constants";

type PersonProps = {
  name: string;
  email: string;
  phone: string;
  company: string;
  campaign?: string;
  date: string;
  task: string;
  dateTask: string;
  businessStage: string;
  labels: string[];
  diffDay: string;
  lastAccess: string;
  avatar: string;
};

const TableListCatchment: React.FC<{ people: PersonProps[] }> = ({
  people,
}) => {
  const optionsStatusBusiness = getOptionsStatusBusiness();

  const columns = [
    {
      header: "USUARIO",
      accessor: "name",
      render: (person: PersonProps) => (
        <ColumnPersonInformationAvatar
          image={person.avatar}
          name={person.name}
          email={person.email}
        />
      ),
    },
    {
      header: "COMPAÑIA & FILIAL",
      accessor: "campaign",
      render: (person: PersonProps) => <p className="lowercase">{person.company}</p>
    },
    {
      header: "ÚLTIMO ACCESO",
      accessor: "businessStage",
      render: (person: PersonProps) => (
        <ColumnDate date={person.lastAccess} />
      ),
    },
    {
      header: "DÍAS SIN ASISTIR",
      accessor: "labels",
      render: (person: PersonProps) => <p>{person.diffDay}</p>,
    },
    /*
    {
      header: "Tareas",
      accessor: "task",
      render: (person: PersonProps) => (
        <ColumnTask task={person.task} date={person.dateTask} />
      ),
    },
    {
      header: "",
      accessor: "email",
      render: () => <ColumnButton name="Crear cliente" />,
    },
    */
  ];

  return (
    <div>
      <div className="mb-4 px-4 mt-5">
        <h3 className="text-2xl">Usuarios ({people.length})</h3>
        <p className="text-sm text-gray-500">Listado</p>
      </div>
      <Table data={people} columns={columns} />
    </div>
  );
};

export default TableListCatchment;
